"use client";

import { useReportWebVitals } from "next/web-vitals";

import { reportWebVital } from "./web-vitals";

/** Reports the page's Core Web Vitals (`web-vitals.ts`). Mounted once in the root layout; draws nothing. */
export function WebVitalsReporter() {
  useReportWebVitals(reportWebVital);

  return null;
}
